export const DROPDOWN_STATE_BY_COUNTRY = ['US', 'CA'];
